// extracted by mini-css-extract-plugin
export default {"select":"Select_select__V237b","error":"Select_error__uJ69v"};